// extracted by mini-css-extract-plugin
export var item = "instagram-section-module--item--uAtsm";
export var list = "instagram-section-module--list--5CFCw";
export var subtitle = "instagram-section-module--subtitle--DiS5r";
export var title = "instagram-section-module--title--R4EkI";
export var visible = "instagram-section-module--visible--Nt4Dt";